document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".shopify-tab");
  const contents = document.querySelectorAll(".shopify-tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      const target = this.getAttribute("data-tab");

      // Entferne 'active' von allen Tabs und Inhalten
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      // Aktiviere den angeklickten Tab und das zugehörige Content-Element
      this.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});
